import React from "react";
import { withRouter } from "react-router-dom";
import { congratulationsImage } from "../../../../assets";

function Congratulations(props) {
  const { isDirectRequest, createdRequest } = props;
  console.log(createdRequest, "request---Details");

  const handleViewDetails = () => {
    props.history.push(
      "/view-request/" + createdRequest.Request_ID.public_access_link
    );
  };

  return (
    <>
      <section className="main-content address-page">
        <div className="container">
          <div className="add-items-wrapper pt-100 pb-5">
            <div className="to-do-img text-center pb-40">
              <img src={congratulationsImage} />
            </div>
            <div className="row text-center justify-content-center">
              <div className="col-12 col-sm-8 small-font-size text-center">
                <h1 className="text-center text-uppercase">Congratulations!</h1>
                {!isDirectRequest && (
                <p
                  className="light-grey-color font-weight-bod"
                  style={{ fontSize: 20, lineHeight: 1.5 }}
                >
                    Your Moving request has been sent to best licensed/insured
                    moving companies in your area based on the info you
                    provided. You should start getting price range bids shortly.
                  </p>
                )}
                {isDirectRequest && (
                  <p
                    className="light-grey-color font-weight-bod"
                    style={{ fontSize: 20, lineHeight: 1.5 }}
                  >
                    Thank you for submitting a request. One of our relocation
                    specialists will contact you shortly in order to ask you a
                    few more questions and provide you with a detailed moving
                    quote. You can also call us at your earliest convenience at{" "}
                    <a href={"tel:" + createdRequest.phone}>
                      {createdRequest.phone}
                    </a>
                    .
                </p>
                )}
              </div>
            </div>
            <div className="row pt-30 justify-content-center">
              <div className="col-12 col-sm-8 col-md-6">
                {!isDirectRequest ? (
                <button
                  className="custom-buton custom-buton-large w-100"
                    onClick={() => props.history.push("/dashboard")}
                >
                  go to my requests page
                </button>
                ) : (
                  <button
                    className="custom-buton custom-buton-large w-100"
                    onClick={handleViewDetails}
                  >
                    go to my request details
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default withRouter(Congratulations);
